/**
=========================================================
* Soft UI Dashboard React - v2.0.0
=========================================================

* Product Page: https://www.creative-tim.com/product/soft-ui-dashboard-material-ui
* Copyright 2021 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/
import { useEffect } from "react";

import { useNavigate } from "react-router-dom";
import AuthApi from "api/auth";
import { useAuth } from "auth-context/auth.context";

function SignOutMSM() {
  const navigate = useNavigate();
  const { user, setUser } = useAuth();

  const handleLogout = async () => {
    console.log(user);
    await AuthApi.Logout(user);
    await setUser(null);
    localStorage.removeItem("user");
    return navigate("/admin-multi-sinar");
  };

  useEffect(() => {
    handleLogout();
  }, []);

  return null;
}

export default SignOutMSM;
